export const SANS_SERIF_FONTS = [
  'Inter',
  'Poppins',
  'Montserrat',
  'Work Sans',
  'Space Grotesk',
  'Sora',
  'Manrope',
  'Darker Grotesque',
  'Roboto',
  'Noto Sans',
  'Open Sans',
  'Lato',
  'Nunito',
  'Source Sans Pro',
  'Fira Sans',
  'Oxygen',
  'Raleway',
  'Quicksand',
  'IBM Plex Sans',
  'DM Sans',
  'Public Sans',
  'Outfit',
  'Plus Jakarta Sans',
  // 'Geist',
];

export const SERIF_FONTS = [
  'Lora',
  'Merriweather',
  'Corben',
  'Literata',
  'Noto Serif',
  'Roboto Serif',
  'PT Serif',
  'Source Serif Pro',
  'EB Garamond',
  'Libre Baskerville',
  'Cardo',
  'IBM Plex Serif',
  'Bitter',
  'Zilla Slab',
  'Alegreya',
  'Spectral',
  'Crimson Pro',
];
